import getUserBrowseHistory from '@tcp/core/src/queries/getUserPersonalization.query.graphql';
import saveUserBrowseHistory from '@tcp/core/src/queries/updateUserPersonalization.query.graphql';
import {
  updateStoreWithAPIResponse,
  hasValidUserSelection,
  getRecentSelection,
} from '@tcp/core/src/utils/userPersonalization';
import logger from '@tcp/core/src/utils/loggerInstance';
import { executeStatefulGraphQLQuery } from '../../handler';

export const saveUserbrowseSelectionApi = async (data) => {
  const recentSelection = getRecentSelection();
  if (recentSelection && recentSelection.length > 0) {
    const finalSelection = recentSelection.map((i) => {
      const item = { ...i };
      item.status = data?.payload;
      return item;
    });
    executeStatefulGraphQLQuery({
      query: saveUserBrowseHistory,
      variables: {
        userBrowseHistoryDTO: { browseData: finalSelection },
      },
      type: 'mutation',
      fetchPolicy: 'no-cache',
    })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        logger.error(err);
      });
  }
};

export const getUserSelectionApi = async (payload) => {
  const isLogin = payload && payload.isLogin;
  const hasAppValidUser = hasValidUserSelection();
  if (!hasAppValidUser || isLogin) {
    return executeStatefulGraphQLQuery({
      query: getUserBrowseHistory,
      fetchPolicy: 'no-cache',
    })
      .then(async (res) => {
        if (res && res.data?.getUserBrowseHistory) {
          await updateStoreWithAPIResponse(res.data.getUserBrowseHistory.browseData);
        }
      })
      .catch((err) => {
        logger.error(err);
      });
  }

  return false;
};
